import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab958880"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "selectbox_placeholder"
}
const _hoisted_2 = { class: "selectbox_placeholder_text" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  style: {"display":"none"}
}, null, -1))
const _hoisted_5 = ["value", "selected"]

import { PropType, toRefs } from 'vue';


export type Options = {
  value: string | number;
  label: string;
}[];

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectBox',
  props: {
  placeholder: {
    type: String,
    default: '',
  },
  modelValue: {
    type: [String, Number] as PropType<string | number | null>,
    default: null,
  },
  options: {
    type: Object as PropType<Options>,
    required: true,
  },
  hasCancelButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "blue", "clear"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string): void;
  (e: 'blue', value: Event): true;
  (e: 'clear'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const { options } = toRefs(props);



const blue = (e: Event) => {
  emits('blue', e);
};

const change = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emits('update:modelValue', target.value);
};
const clear = () => {
  emits('update:modelValue', '');
  emits('clear');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selectbox", { selectbox_type_no_cancel: !props.hasCancelButton }])
  }, [
    (props.placeholder && (props.modelValue === null || props.modelValue === ''))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.placeholder), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("select", {
      value: props.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (change($event))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (blue($event)))
    }, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value,
          selected: option.value === __props.modelValue
        }, _toDisplayString(option.label), 9, _hoisted_5))
      }), 128))
    ], 40, _hoisted_3),
    (props.modelValue && props.hasCancelButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: clear,
          class: "selectbox_cancel"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})